<template>
    <div style="background: #fff" v-loading="pdfLoading">
        <div class="box" v-if="showResult&&hasFinished">
            <h1 class="serviceTestTitle">Claim Form Exam</h1>
            <div>
                <!--
            <span>Of the parts of this exam that can be automatically graded you have recieved </span>
            <span>{{getScores}}</span>/{{totalNum}} ({{correctPercent}})-->
            <span>Thank you for completing this knowledge assessment!</span><br/>
            <span>Please allow up to three business days while we review your application.</span>
            <br>
            </div>
            <el-button class="yellowBtn" style="margin-top: 10px;" @click="goPre">Back</el-button>
        </div>

        <el-form v-show="!pdfLoading" :model="form" :rules="rules" ref="form" v-if="!showResult&&hasFinished">
            <div class="smallBox minH150">
                <span class="viewPDF">
                    <el-image :src="wrong" style="width: 20px" v-if="isAdmin&&!correctSub1"></el-image>
                    #1 <u @click="openPdf(1)">View PDF</u></span>
                <el-form-item prop="sub0">
                    <div class="titleInner">
                        <el-image :src="wrong" style="width: 20px" v-if="isAdmin&&form.sub0!=1"></el-image>
                        Does this claim require an attachment and/or narrative?</div>
                    <el-select ref="sub0" v-model="form.sub0" placeholder="" class="select" :disabled="isAdmin">
                        <el-option label="Yes" :value="1"></el-option>
                        <el-option label="No" :value="0"></el-option>
                    </el-select>
                    <div class="key" v-if="isAdmin&&form.sub0!=1">
                        Yes
                    </div>
                </el-form-item>
                <el-form-item prop="sub1" class="mt20">
                    <div class="titleInner">If yes,why and what would you attach?</div>
                    <el-input ref="sub1" class="textarea" type="textarea" v-model="form.sub1" :disabled="isAdmin"></el-input>
                </el-form-item>
            </div>

            <div class="smallBox" style="min-height: 220px">
                <span class="viewPDF"><el-image :src="wrong" style="width: 20px" v-if="isAdmin&&!correctSub2"></el-image>
                    #2 <u @click="openPdf(2)">View PDF</u></span>
                <el-form-item prop="sub2">
                    <div class="titleInner">
                        <el-image :src="wrong" style="width: 20px" v-if="isAdmin&&form.sub2!=0"></el-image>
                        If you were sending this claim electronically and Educators Mutual did not accept electronic
                    attachments,would you need to print this claim and mail it with an attachment?</div>
                    <el-select ref="sub2" v-model="form.sub2" placeholder="" class="select" :disabled="isAdmin">
                        <el-option label="Yes" :value="1"></el-option>
                        <el-option label="No" :value="0"></el-option>
                    </el-select>
                    <div class="key" v-if="isAdmin&&form.sub2!=0">
                        No
                    </div>
                </el-form-item>
                <el-form-item prop="sub3" class="mt20">
                    <p class="titleInner">Why or why not?</p>
                    <el-input ref="sub3" class="textarea" type="textarea" v-model="form.sub3" :disabled="isAdmin"></el-input>
                </el-form-item>
            </div>

            <div class="smallBox" style="min-height: 220px">
                <span class="viewPDF"><el-image :src="wrong" style="width: 20px" v-if="isAdmin&&!correctSub3"></el-image>
                    #3 <u @click="openPdf(3)">View PDF</u></span>
                <el-form-item prop="sub4">
                    <div class="titleInner">
                        <el-image :src="wrong" style="width: 20px" v-if="isAdmin&&form.sub4!=0"></el-image>
                        Sometimes insurance requires a narrative and diagnostic
                    x ray for composite fillings. Based on the services submitted on this claim would you need to send
                    a narrative and x-ray?</div>
                    <el-select ref="sub4" v-model="form.sub4" placeholder="" class="select" :disabled="isAdmin">
                        <el-option label="Yes" :value="1"></el-option>
                        <el-option label="No" :value="0"></el-option>
                    </el-select>
                    <div class="key" v-if="isAdmin&&form.sub4!=0">
                        No
                    </div>
                </el-form-item>
                <el-form-item prop="sub5" class="mt20">
                    <p class="titleInner">Why or why not?</p>
                    <el-input ref="sub5" class="textarea" type="textarea" v-model="form.sub5" :disabled="isAdmin"></el-input>
                </el-form-item>
            </div>

            <div class="smallBox" style="min-height: 360px">
                <span class="viewPDF"><el-image :src="wrong" style="width: 20px" v-if="isAdmin&&!correctSub4"></el-image>
                    #4 <u @click="openPdf(4)">View PDF</u></span>
                <el-form-item prop="sub6">
                    <el-image :src="wrong" style="width: 20px" v-if="isAdmin&&form.sub6!=1"></el-image>
                    <div class="titleInner">Based on the service listed on this claim would you need to send any additional information with it for processing?</div>
                    <el-select ref="sub6" v-model="form.sub6" placeholder="" class="select" :disabled="pdfVisible">
                        <el-option label="Yes" :value="1"></el-option>
                        <el-option label="No" :value="0"></el-option>
                    </el-select>
                    <div class="key" v-if="isAdmin&&form.sub6!=1">
                        Yes
                    </div>
                </el-form-item>
                <el-form-item prop="sub7" class="mt20">
                    <p class="titleInner">Why or why not?</p>
                    <el-input ref="sub7" class="textarea" type="textarea" v-model="form.sub7" :disabled="isAdmin"></el-input>
                </el-form-item>

                <el-form-item prop="sub8" class="mt60" ref="sub8">
                    <p class="titleInner">
                        <el-image :src="wrong" style="width: 20px" v-if="isAdmin&&!(form.sub8.a&&form.sub8.b&&form.sub8.b)"></el-image>
                        If you need to send something what is it?</p>
                    <div class="select">
                        <el-checkbox v-model="form.sub8.a" :disabled="isAdmin">Narrative</el-checkbox><br>
                        <el-checkbox v-model="form.sub8.b" :disabled="isAdmin">Pre Operative X-ray</el-checkbox><br>
                        <el-checkbox v-model="form.sub8.c" :disabled="isAdmin">Post Operative X-ray</el-checkbox>
                    </div>
                    <div class="key" v-if="isAdmin&&!(form.sub8.a&&form.sub8.b&&form.sub8.c)">
                        Narrative
                    </div>
                    <div class="key mt30" v-if="isAdmin&&!(form.sub8.a&&form.sub8.b&&form.sub8.c)">
                        Pre Operative X-ray
                    </div>
                    <div class="key mt60" v-if="isAdmin&&!(form.sub8.a&&form.sub8.b&&form.sub8.c)">
                        Post Operative X-ray
                    </div>
                </el-form-item>
            </div>

            <div class="smallBox" style="min-height: 340px">
                <span class="viewPDF"><el-image :src="wrong" style="width: 20px" v-if="isAdmin&&!correctSub5"></el-image>
                    #5 <u @click="openPdf(5)">View PDF</u></span>
                <el-form-item prop="sub9">
                    <div class="titleInner">
                        <el-image :src="wrong" style="width: 20px" v-if="isAdmin&&form.sub9!=0"></el-image>
                        Based on the claim form who is the patient?</div>
                    <el-radio-group ref="sub9" v-model="form.sub9" placeholder="" class="radioGroup" :disabled="isAdmin">
                        <el-radio :label="0">Beverlee Toone</el-radio><br>
                        <el-radio :label="1">Bekki Patton</el-radio>
                    </el-radio-group>
                    <div class="key" v-if="isAdmin&&form.sub9!=0">
                        Beverlee Toone
                    </div>
                </el-form-item>
                <el-form-item prop="sub10" class="mt60">
                    <p class="titleInner">
                        <el-image :src="wrong" style="width: 20px" v-if="isAdmin&&form.sub10!=0"></el-image>
                        Who is the insured?</p>
                    <el-radio-group ref="sub10" v-model="form.sub10" placeholder="" class="radioGroup" :disabled="isAdmin">
                        <el-radio :label="0">Beverlee Toone</el-radio><br>
                        <el-radio :label="1">Bekki Patton</el-radio>
                    </el-radio-group>
                    <div class="key" v-if="isAdmin&&form.sub10!=0">
                        Beverlee Toone
                    </div>
                </el-form-item>
                <el-form-item prop="sub11" class="mt60">
                    <p class="titleInner">
                        <el-image :src="wrong" style="width: 20px" v-if="isAdmin&&form.sub11!=1"></el-image>
                        Is there an assignment of benefits?</p>
                    <el-select ref="sub11" v-model="form.sub11" placeholder="" class="select" :disabled="isAdmin">
                        <el-option label="Yes" :value="1"></el-option>
                        <el-option label="No" :value="0"></el-option>
                    </el-select>
                    <div class="key" v-if="isAdmin&&form.sub11!=1">
                        Yes
                    </div>
                </el-form-item>
                <el-form-item prop="sub12" class="mt40">
                    <p class="titleInner">
                        <el-image :src="wrong" style="width: 20px" v-if="isAdmin&&form.sub12!=1"></el-image>
                        If so, to whom?</p>
                    <div class="titleInner">
                        <el-radio-group ref="sub12" v-model="form.sub12" placeholder="" class="radioGroup" :disabled="isAdmin">
                            <el-radio :label="0">Beverlee Toone</el-radio><br>
                            <el-radio :label="1">Office</el-radio>
                        </el-radio-group>
                    </div>
                    <div class="key" v-if="isAdmin&&form.sub12!=1">
                        Office
                    </div>
                </el-form-item>
            </div>

            <div class="smallBox" style="min-height: 420px">
                <span class="viewPDF"><el-image :src="wrong" style="width: 20px" v-if="isAdmin&&!correctSub6"></el-image>
                    #6 <u @click="openPdf(6)">View PDF</u></span>
                <el-form-item prop="sub13">
                    <div class="titleInner">
                        <el-image :src="wrong" style="width: 20px" v-if="isAdmin&&form.sub13!=0"></el-image>
                        Based on the claim form who is the secondary company?</div>
                    <el-radio-group ref="sub13" v-model="form.sub13" placeholder="" class="radioGroup" :disabled="isAdmin">
                        <el-radio :label="0">GEHA</el-radio><br>
                        <el-radio :label="1">ITPE</el-radio><br>
                        <el-radio :label="2">None</el-radio>
                    </el-radio-group>
                    <div class="key" v-if="isAdmin&&form.sub13!=0">
                        GEHA
                    </div>
                </el-form-item>
                <el-form-item prop="sub14" class="mt70">
                    <p class="titleInner">
                        <el-image :src="wrong" style="width: 20px" v-if="isAdmin&&form.sub14!=0"></el-image>
                        Is this claim for primary or secondary insurance?</p>
                    <el-radio-group ref="sub14" v-model="form.sub14" placeholder="" class="radioGroup" :disabled="isAdmin">
                        <el-radio :label="0">Primary</el-radio><br>
                        <el-radio :label="1">Secondary</el-radio>
                    </el-radio-group>
                    <div class="key" v-if="isAdmin&&form.sub14!=0">
                        Primary
                    </div>
                </el-form-item>
                <el-form-item prop="sub15" class="mt60">
                    <p class="titleInner">
                        <el-image :src="wrong" style="width: 20px" v-if="isAdmin&&form.sub15!=1"></el-image>
                        Does anything need to be sent with this claim?</p>
                    <div class="titleInner">
                        <el-select ref="sub15" v-model="form.sub15" placeholder="" class="select" :disabled="isAdmin">
                            <el-option label="Yes" :value="1"></el-option>
                            <el-option label="No" :value="0"></el-option>
                        </el-select>
                    </div>
                    <div class="key" v-if="isAdmin&&form.sub15!=1">
                        Yes
                    </div>
                </el-form-item>

                <el-form-item prop="sub16" class="mt40" ref="sub16">
                    <p class="titleInner">
                        <el-image :src="wrong" style="width: 20px" v-if="isAdmin&&!(form.sub16.a&&form.sub16.a&&form.sub16.a)"></el-image>
                        If so, what?</p>
                    <div class="select">
                        <el-checkbox v-model="form.sub16.a" :disabled="isAdmin">Narrative</el-checkbox><br>
                        <el-checkbox v-model="form.sub16.b" :disabled="isAdmin">Pre Operative X-ray</el-checkbox><br>
                        <el-checkbox v-model="form.sub16.c" :disabled="isAdmin">Post Operative X-ray</el-checkbox><br>
                    </div>
                    <div class="key" v-if="isAdmin&&!(form.sub16.a&&form.sub16.a&&form.sub16.a)">
                        Narrative
                    </div>
                    <div class="key mt30" v-if="isAdmin&&!(form.sub16.a&&form.sub16.a&&form.sub16.a)">
                        Pre Operative X-ray
                    </div>
                    <div class="key mt60" v-if="isAdmin&&!(form.sub16.a&&form.sub16.a&&form.sub16.a)">
                        Post Operative X-ray
                    </div>
                </el-form-item>
            </div>

            <div class="smallBox" style="min-height: 320px">
                <span class="viewPDF"><el-image :src="wrong" style="width: 20px" v-if="isAdmin&&!correctSub7"></el-image>
                    #7 <u @click="openPdf(7)">View PDF</u></span>
                <el-form-item prop="sub17">
                    <div class="titleInner">
                        <el-image :src="wrong" style="width: 20px" v-if="isAdmin&&form.sub17!=1"></el-image>
                        Based on the claim form who is the patient?</div>
                    <el-radio-group ref="sub17" v-model="form.sub17" placeholder="" class="radioGroup" :disabled="isAdmin">
                        <el-radio :label="0">Jason Sanlon</el-radio><br>
                        <el-radio :label="1">Andera Sanlon</el-radio><br>
                        <el-radio :label="2">Bekki Patton</el-radio>
                    </el-radio-group>
                    <div class="key" v-if="isAdmin&&form.sub17!=1">
                        Andera Sanlon
                    </div>
                </el-form-item>
                <el-form-item prop="sub18" class="mt70">
                    <p class="titleInner">
                        <el-image :src="wrong" style="width: 20px" v-if="isAdmin&&form.sub18!=1"></el-image>
                        What is their relationship to the insured?</p>
                    <el-radio-group ref="sub18" v-model="form.sub18" placeholder="" class="radioGroup" :disabled="isAdmin">
                        <el-radio :label="0">Self</el-radio><br>
                        <el-radio :label="1">Spouse</el-radio><br>
                        <el-radio :label="2">Dependant Child</el-radio><br>
                        <el-radio :label="3">Other</el-radio>
                    </el-radio-group>
                    <div class="key" v-if="isAdmin&&form.sub18!=1">
                        Spouse
                    </div>
                </el-form-item>
                <el-form-item prop="sub19" style="margin-top: 100px">
                    <p class="titleInner">
                        <el-image :src="wrong" style="width: 20px" v-if="isAdmin&&form.sub19!='7/2/1980'"></el-image>
                        What is the DOB of the insured?</p>
                    <el-date-picker
                            :disabled="isAdmin"
                            class="select"
                            ref="sub19"
                            v-model="form.sub19"
                            type="date"
                            placeholder=""
                            format="M/d/yyyy"
                            value-format="M/d/yyyy"
                    >
                    </el-date-picker>
<!--                    <el-input ref="sub19" style="width: 25%" class="select" v-model="form.sub19" :disabled="isAdmin"></el-input>-->
                    <div class="key" style="margin-left: 20px" v-if="isAdmin&&form.sub19!='7/2/1980'">
                        7/2/1980
                    </div>
                </el-form-item>
            </div>
            <div style="margin-top:10px;margin-bottom: 20px">
                <el-button class="yellowBtn" @click="submitPrepare" v-if="!isAdmin">Submit</el-button>
                <el-button class="grayBtn" @click="cancel">Cancel</el-button>
                <span style="margin-left:10px" v-if="isAdmin">Exam Completed {{ forMateTime(finishDate,true) }}</span>
            </div>
        </el-form>
        <el-dialog :title="titleName" :visible.sync="pdfVisible">
            <pdf :src="pdfSrc"></pdf>
            <span slot="footer">
                <el-button class="grayBtn" @click="pdfVisible=false">Close</el-button>
            </span>
        </el-dialog>
        <el-dialog title="Confirm" :visible.sync="exitVisible">
            <div>Are you sure you want to cancel the test?</div>
            <span slot="footer">
                <el-button class="yellowBtn" @click="goBack">Yes</el-button>
                <el-button class="grayBtn" @click="exitVisible=false">No</el-button>
            </span>
        </el-dialog>

        <el-dialog title="Confirm" :visible.sync="confirmVisible" width="50%">
            <div style="line-height: 25px;padding: 0 10px;word-wrap:break-word">Caution:this portion of our skills assessment test you are about to view cannot be saved for later. You will
                be scored with no option to return later if you proceed. Do you want to continue?</div>
            <span slot="footer">
                <el-button class="yellowBtn" @click="submit">Yes</el-button>
                <el-button class="grayBtn" @click="confirmVisible=false">No</el-button>
            </span>
        </el-dialog>

        <el-dialog
            title="Assessment Complete"
            :visible.sync="completionDialogVisible"
            :show-close="false"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            width="50%">
            <div style="text-align: center">
                <p>Thank you for completing this knowledge assessment.</p>
                <p>Please allow up to three business days while we review your application.</p>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button class="yellowBtn" @click="handleCompletionConfirm">OK</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    //import pdfSrc from "../../assets/file/ClaimFormExam/Claim1.pdf"
    import wrong from "../../assets/pic/wrong.png"
    import right from "../../assets/pic/right.png"
     import pdf from 'vue-pdf'
    export default {
        name: "claimFormExam",
        components:{pdf},
        data(){
            let validateEmptyThree = (rule, value, callback) => {
                // console.log('here')
                if (!value.a&&!value.b&&!value.c) {
                    callback(new Error('Required'))
                } else {
                    callback()
                }
            }
            return{
                finishDate:'',
                getScores:0,
                insuredDate:'',
                showResult:true,
                hasFinished:false,
                correctNum:0,
                totalNum:20,
                wrong:wrong,
                right:right,
                exitVisible:false,
                confirmVisible:false,
                pdfVisible:false,
                pdfLoading:false,
                pdfSrc:'',
                titleName:'',
                isAdmin:false,
                completionDialogVisible: false, 
                form:{
                    sub0:0,
                    sub1:'',
                    sub2:0,
                    sub3:'',
                    sub4:0,
                    sub5:'',
                    sub6:0,
                    sub7:'',
                    sub8:{},
                    // sub9:0,
                    // sub10:0,
                    sub11:0,
                    // sub12:1,
                    // sub13:0,
                    sub15:0,
                    sub16:{},
                    // sub17:1,
                    // sub18:1,
                     sub19:'',
                },
                possibles:[1,1,1,4,4,6,3],
                scores:[0,0,0,0,0,0,0],
                details:[[],[],[],[],[],[],[]],
                rules:{
                    sub8:[{required: true, message: 'Required', trigger: 'blur'},
                        {validator:validateEmptyThree,trigger: 'blur'}],
                    sub9:[{required: true, message: 'Required', trigger: 'blur'}],
                    sub10:[{required: true, message: 'Required', trigger: 'blur'}],
                    sub12:[{required: true, message: 'Required', trigger: 'blur'}],
                    sub13:[{required: true, message: 'Required', trigger: 'blur'}],
                    sub14:[{required: true, message: 'Required', trigger: 'blur'}],
                    sub16:[{required: true, message: 'Required', trigger: 'blur'},
                        {validator:validateEmptyThree,trigger: 'blur'}],
                    sub17:[{required: true, message: 'Required', trigger: 'blur'}],
                    sub18:[{required: true, message: 'Required', trigger: 'blur'}],
                    sub19:[{required: true, message: 'Required', trigger: 'blur'}],
                }
            }
        },
        computed:{
            /**根据用户自己选择算出正确率**/
            correctPercent(){
                return (this.getScores*100/this.totalNum).toFixed(2)+'%'
            },
            /**判断大题中是否有小题错误，如果有一个错误则显示叉叉*/
            correctSub1(){
                return this.form.sub0==1
            },
            correctSub2(){
                return this.form.sub2==0
            },
            correctSub3(){
                return this.form.sub4==0
            },
            correctSub4(){
                var res8 = this.form.sub8.a&&this.form.sub8.b&&this.form.sub8.c
                return this.form.sub6==1&&res8
            },
            correctSub5(){
                return this.form.sub9==0&&this.form.sub10==0&&this.form.sub11==1&&this.form.sub12==1
            },
            correctSub6(){
                var res16 = this.form.sub16.a&&this.form.sub16.b&&this.form.sub16.c
                return this.form.sub13==0&&this.form.sub14==0&&this.form.sub15==1&&res16
            },
            correctSub7(){

                return this.form.sub17==1&&this.form.sub18==1&&this.form.sub19=='7/2/1980'
            },
        },
        methods:{
            goBack(){
                this.$router.push({path:'/service'})
            },
            goPre(){this.$router.go(-1)},
            calScore(){
                this.scores = [0,0,0,0,0,0,0]
                //1
                if(this.form.sub0==1) {this.scores[0]++;this.correctNum++}
                //2
                if(this.form.sub2==0) {this.scores[1]++;this.correctNum++}
                //3
                if(this.form.sub4==0) {this.scores[2]++;this.correctNum++}
                //4
                if(this.form.sub6==1) {this.scores[3]++;this.correctNum++;}
                if(this.form.sub8.a)this.scores[3]++
                if(this.form.sub8.b)this.scores[3]++
                if(this.form.sub8.c)this.scores[3]++
                if(this.form.sub8.a&&this.form.sub8.b&&this.form.sub8.c){this.correctNum++}
                //5
                if(this.form.sub9==0){this.scores[4]++;this.correctNum++}
                if(this.form.sub10==0){this.scores[4]++;this.correctNum++}
                if(this.form.sub11==1){this.scores[4]++;this.correctNum++}
                if(this.form.sub12==1){this.scores[4]++;this.correctNum++}
                //6
                if(this.form.sub13==0){this.scores[5]++;this.correctNum++}
                if(this.form.sub14==0){this.scores[5]++;this.correctNum++}
                if(this.form.sub15==0){this.scores[5]++;this.correctNum++}
                if(this.form.sub16.a)this.scores[5]++
                if(this.form.sub16.b)this.scores[5]++
                if(this.form.sub16.c)this.scores[5]++
                if(this.form.sub16.a&&this.form.sub16.b&&this.form.sub16.c){this.correctNum++}
                //7
                if(this.form.sub17==1){this.scores[6]++;this.correctNum++}
                if(this.form.sub18==1){this.scores[6]++;this.correctNum++}
                if(this.form.sub19=='7/2/1980'){this.scores[6]++;this.correctNum++}
                var goal=0
                this.scores.forEach(item=>{
                    goal+=item
                })
                this.getScores = goal
            },
            openPdf(index){
                this.pdfVisible=true
                this.titleName="Claim"+index+".pdf"
                this.pdfSrc=require('../../assets/file/ClaimFormExam/Claim'+index+'.pdf')

            },
            deconstructData(data){//解构获取到的后台数据并用于显示
                if(!data)return
                var jsonData = data.detail||[]
                this.finishDate = data.finishDate 
                if(jsonData.length!=7){
                    // console.log('答题数据错误')
                    return
                }
                var form = JSON.parse(JSON.stringify(this.form))
                // console.log('form',form)
                for(var i = 0;i<jsonData.length;i++){
                    var item = jsonData[i].detail
                    for(var j=0;j<item.length;j++){
                        var child = item[j]
                        if(i==0){
                            if(j<2) this.form['sub'+j]=child
                        }else if(i==1){
                            if(j<2) this.form['sub'+(2+j)]=child
                        }else if(i==2){
                            if(j<2) this.form['sub'+(4+j)]=child
                        }else if(i==3){
                            if(j<3){
                                if(j==2){
                                    // console.log('form',form.sub8)
                                    // console.log('form',this.form.sub8)
                                    if(child.indexOf('Narrative')>=0)this.form['sub'+(6+j)].a=true
                                    if(child.indexOf('Pre Operative X-ray')>=0)this.form['sub'+(6+j)].b=true
                                    if(child.indexOf('Post Operative X-ray')>=0)this.form['sub'+(6+j)].c=true
                                }else{
                                    this.form['sub'+(6+j)]=child
                                }
                            }

                        }else if(i==4){
                            if(j<4){
                                if(j==0||j==1){
                                    if(child=='Beverlee Toone')this.form['sub'+(j+9)]=0
                                    else if(child=='Bekki Patton')this.form['sub'+(j+9)]=1
                                }else if(j==3){
                                    if(child=='Beverlee Toone')this.form['sub'+(j+9)]=0
                                    else if(child=='Office')this.form['sub'+(j+9)]=1
                                }else{
                                    this.form['sub'+(9+j)]=child
                                }
                            }
                        }else if(i==5){
                            if(j<4){
                                if(j==0){
                                    if(child=='GEHA')this.form['sub'+(13+j)]=0
                                    else if(child=='ITPE')this.form['sub'+(13+j)]=1
                                    else if(child=='None')this.form['sub'+(13+j)]=2
                                }else if(j==1){
                                    if(child=='Primary')this.form['sub'+(13+j)]=0
                                    else if(child=='Secondary')this.form['sub'+(13+j)]=1
                                }else if(j==3){
                                    if(child.indexOf('Narrative')>=0)this.form['sub'+(13+j)].a=true
                                    if(child.indexOf('Pre Operative X-ray')>=0)this.form['sub'+(13+j)].b=true
                                    if(child.indexOf('Post Operative X-ray')>=0)this.form['sub'+(13+j)].c=true
                                }else{
                                    this.form['sub'+(13+j)]=child
                                }
                            }
                        }else if(i==6){
                            if(j<3){
                                if(j==0){
                                    if(child=='Jason Sanlon')this.form['sub'+(17+j)]=0
                                    else if(child=='Andera Sanlon')this.form['sub'+(17+j)]=1
                                    else if(child=='Bekki Patton')this.form['sub'+(17+j)]=2
                                }else if(j==1){
                                    if(child=='Self')this.form['sub'+(17+j)]=0
                                    else if(child=='Spouse')this.form['sub'+(17+j)]=1
                                    else if(child=='Dependant Child')this.form['sub'+(17+j)]=2
                                    else if(child=='Child')this.form['sub'+(17+j)]=3
                                }else{
                                    this.form['sub'+(17+j)]=child
                                }
                            }
                        }
                    }
                }
                this.calScore()
            },
            rebuildData(){//重构传给后台的数据,测试通过
                this.details=[[],[],[],[],[],[],[]]
                for(var i=0;i<20;i++) {
                    if (i >= 0 && i < 2) {
                        this.details[0].push(this.form['sub' + i])
                    } else if (i >= 2 && i < 4) {
                        this.details[1].push(this.form['sub' + i])
                    } else if (i >= 4 && i < 6) {
                        this.details[2].push(this.form['sub' + i])
                    } else if (i >= 6 && i < 9) {
                        if (i == 8) {
                            var arr = []
                            var str1 = ''
                            if (this.form['sub' + i].a) arr.push('Narrative')
                            if (this.form['sub' + i].b) arr.push('Pre Operative X-ray')
                            if (this.form['sub' + i].c) arr.push('Post Operative X-ray')
                            str1 = arr.join('|')
                            this.details[3].push(str1)
                        } else {
                            this.details[3].push(this.form['sub' + i])
                        }
                    } else if (i >= 9 && i < 13) {
                        if (i == 9 || i == 10) {
                            var str2 = ''
                            if (this.form['sub' + i] == 0) str2 = 'Beverlee Toone'
                            else str2 = 'Bekki Patton'
                            this.details[4].push(str2)
                        } else if (i == 12) {
                            var str3 = ''
                            if (this.form['sub' + i] == 0) str3 = 'Beverlee Toone'
                            else str3 = 'Office'
                            this.details[4].push(str3)
                        } else {
                            this.details[4].push(this.form['sub' + i])
                        }
                    } else if (i >= 13 && i < 17) {
                        if (i == 13) {
                            var str4 = ''
                            if (this.form['sub' + i] == 0) str4 = 'GEHA'
                            else if (this.form['sub' + i] == 1) str4 = 'ITPE'
                            else str4 = 'None'
                            this.details[5].push(str4)
                        } else if (i == 14) {
                            var str5 = ''
                            if (this.form['sub' + i] == 0) str5 = 'Primary'
                            else str5 = 'Secondary'
                            this.details[5].push(str5)
                        } else if (i == 16) {
                            var arr1 = []
                            var str21 = ''
                            if (this.form['sub' + i].a) arr1.push('Narrative')
                            if (this.form['sub' + i].b) arr1.push('Pre Operative X-ray')
                            if (this.form['sub' + i].c) arr1.push('Post Operative X-ray')
                            str21 = arr.join('|')
                            this.details[5].push(str21)
                        } else {
                            this.details[5].push(this.form['sub' + i])
                        }
                    } else if (i >= 17 && i < 20) {
                        if (i == 17) {
                            var str7 = ''
                            if (this.form['sub' + i] == 0) str7 = 'Jason Sanlon'
                            else if (this.form['sub' + i] == 1) str7 = 'Andera Sanlon'
                            else str7 = 'Bekki Patton'
                            this.details[6].push(str7)
                        } else if (i == 18) {
                            var str8 = ''
                            if (this.form['sub' + i] == 0) str8 = 'Self'
                            else if (this.form['sub' + i] == 1) str8 = 'Spouse'
                            else if (this.form['sub' + i] == 2) str8 = 'Dependant Child'
                            else str8 = 'Child'
                            this.details[6].push(str8)
                        } else {
                            this.details[6].push(this.form['sub' + i])
                        }
                    }
                }
            },
            submit(){
                var score=0,possible=0
                this.confirmVisible=false
                this.rebuildData()
                // console.log('传参',this.details)
                this.calScore()
                score= this.scores.reduce(function(sum,number){ //sum2 前两个数的和
                    return sum + number;
                },0)
                possible= this.possibles.reduce(function(sum,number){ //sum2 前两个数的和
                    return sum + number;
                },0)
                var list = []
                for(var i=0;i< 7;i++){
                    var obj = {}
                    obj.score = this.scores[i]
                    obj.possible = this.possibles[i]
                    obj.detail = this.details[i]
                    list.push(obj)
                }
                // console.log('得分',this.scores)
                var storeService = this.$store.state.serviceInfo
                //var positionInfo = this.$store.state.positionInfo
                var params={}
                params.serviceId =storeService.serviceId
                params.versionId = storeService.serviceVersion
                params.score = score
                params.possible = possible
                params.positionId = 0
                params.type='Claim Form'
                params.detail = JSON.stringify(list)
                params.applicantEmail=localStorage.getItem('email')
                // console.log('claim传递的参数',params.detail)
                this.pdfLoading=true
                this.$axios.post(this.$URL.dentalbillingUrl,params).then(res=>{
                    this.pdfLoading=false
                    if(res.code==0){
                        var finishModule = this.$store.state.finished
                        finishModule['Claim']=1
                        this.showResult=true
                        this.$store.commit('saveFinishModule',finishModule)
                        this.nextStep()
                    }else{
                        this.$message.error({message:res.msg})
                    }
                }).catch(err=>{
                    this.pdfLoading=false
                    this.$message.error({message:err})
                })
            },
            nextStep(){
                var flags = this.$store.state.finished
                if(flags['EOB']==0){
                    this.$emit('changeIndex','0')
                    this.$emit('changeClaimStatus')
                    window.scrollTo(0,0);
                }else if(flags['Radio']==0){
                    this.$emit('changeIndex','1')
                    this.$emit('changeClaimStatus')
                    window.scrollTo(0,0);
                }else{
                    this.completionDialogVisible = true
                }
            },
            handleCompletionConfirm() {
                this.completionDialogVisible = false
                this.goBack()
            },
            submitPrepare(){
                this.$refs['form'].clearValidate()
                this.$nextTick(() => {
                    this.$refs['form'].validate((valid,object) => {
                        if (valid) {
                            // console.log('submit',this.form)
                            this.confirmVisible=true
                        }else {
                            var obj = Object.keys(object)[0]
                            let dom = this.$refs[obj]
                            dom.$el.scrollIntoView({
                                //滚动到指定节点
                                block: 'center', //值有start,center,end，nearest，当前显示在视图区域中间
                                behavior: 'smooth' //值有auto、instant,smooth，缓动动画（当前是慢速的）
                            })
                            // console.log('error submit!!');
                            return false;
                        }
                    })
                })
            },
            cancel(){
                this.exitVisible=true
            },
            getClaimFormData(email){
                this.pdfLoading=true
                this.$axios.get(this.$URL.dentalbillingUrl,{params:{email:email,type:'Claim Form'}}).then(res=>{
                    this.pdfLoading=false
                    if(res&&res.code==0){
                        this.hasFinished=true
                        var data = res.data
                        var finishModule = this.$store.state.finished
                        if(data&&data.detail!=null){
                            // console.log('Claim 测试已经做了！')
                            finishModule['Claim']=1
                            if(this.isAdmin)this.showResult=false
                            else this.showResult=true
                            this.deconstructData(data)
                            this.$emit('changeStatus')
                        }else{
                            finishModule['Claim']=0
                            // console.log('Claim 测试还没做！')
                            this.showResult=false
                        }
                        this.$store.commit('saveFinishModule',finishModule)
                        // console.log('已做过1',this.$store.state.finished)
                    }else{
                        this.$message.error({message:res.msg})
                    }
                }).catch(err=>{
                    this.pdfLoading=false
                    this.$message.error({message:err})
                })
            }
        },
        created() {
            var email
            if(this.$route&&this.$route.query.model=='review'&&this.$route.query.verify){
                this.isAdmin=true
                email = this.$route.query.email
                this.showResult=false
            }else{
                email = localStorage.getItem('email')
                this.isAdmin=false
                this.showResult=false
                //when no serviceid info, go back to service list
                var storeService = this.$store.state.serviceInfo
                // console.log('get serviceId:' + storeService.serviceId)
                if(storeService.serviceId == undefined){
                    this.$router.push({path:'/service'})
                    return;
                }
            }
            this.getClaimFormData(email)
        }
    }
</script>

<style scoped>
    .el-select >>> .el-input{
        width: 68px;
    }
    .el-select >>> .el-input .el-input__inner{
        background: #fff!important;
        font-size: 12px!important;
        line-height: 40px!important;
        border-radius: 0px!important;
        height: 30px!important;
    }
    .el-select >>> .el-input .el-input__icon{
        width: 15px!important;
    }
    .el-radio{
        height: 30px!important;
    }
    .smallBox >>>.el-form-item__content{
        line-height: 25px!important;
    }
    .minH150{
        min-height: 150px;
    }

    .minH200{
        min-height: 150px;
    }
    .titleInner{
        width: 35%;
        line-height: 20px;
        margin-top: 10px
    }
    .textarea{
        resize:none;
        width: 30%;
        position: absolute;
        top:20px;
        margin-left: 37%;
        height: 50px
    }
    .radioGroup{
        position: absolute;
        top:8px;
        margin-left: 37%
    }
    .select{
        position: absolute;
        top:8px;
        margin-left: 37%
    }
    .el-image{
        overflow: inherit;
    }
    .key{
        border: 1px solid red;
        width: 24%;
        position: absolute;
        top: 20px;
        font-size: 12px;
        right: 0px;
    }
    @media screen and (max-width: 1200px) {
        .viewPDF{
            left: 22%;
        }
        .viewPDF span,u{
            font-size: 14px;
        }
    }
</style>